import { LOGIN, LOGOUT } from "./types";

export const initialState = {
  isLoggedIn: false,
  data: {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      localStorage.setItem("accessToken", action.accessToken);
      return {
        ...state,
        isLoggedIn: true,
        data: action.user,
      };
    case LOGOUT:
      localStorage.removeItem("accessToken");
      return {
        ...state,
        isLoggedIn: false,
        data: {},
      };
    default:
      return { ...state };
  }
};

export default userReducer;
